import { PATIENT_TYPE, PROCEDURE_SELECTION_TYPE } from '../../utils/constants';
import {
    procedures,
    form,
    setProcedures,
    setProcedureSelectionType,
} from '../../utils/variables';
import { directToAllServices } from './movePages';

export function consultSchedulingListeners() {
    /* Select patient type */
    document.querySelectorAll('.consultScheduling__option').forEach((i) => {
        i.onclick = () => {
            document
                .querySelector('.seeServices__container')
                .classList.add('book-appointment');

            const type = i.getAttribute('data-type');
            let newProcedures = [];

            if (type === PATIENT_TYPE.EXISTING) {
                newProcedures = procedures.filter(
                    (i) => !i.consult
                );
            } else if (type === PATIENT_TYPE.NEW_PATIENT) {
                newProcedures = procedures.filter(
                    (i) => i.consult
                );
                const selectionType =
                    form?.appointment_channel?.selection_type || form?.selection_type;
                if (selectionType === PROCEDURE_SELECTION_TYPE.SINGLE) {
                    setProcedureSelectionType(PROCEDURE_SELECTION_TYPE.SINGLE);
                }
            }

            setProcedures(newProcedures);
            directToAllServices('Get Pricing', newProcedures);
        };
    });
}
